const handleRechargeApp = () => {
  let duration = 0;
  const mutationSubscription = () => {
    const targetDiv = document.querySelector(".subscription-radio");

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const currentClassList = mutation.target.classList;

          if (currentClassList.contains("rc-radio--active")) {
            addDescription();
          }
        }
      });
    });

    const config = { attributes: true };

    observer.observe(targetDiv, config);
  };

  const addDescription = () => {
    const dropdownContainer = document.querySelector(
      ".rc-selling-plans-dropdown"
    );
    const rawHTML = document.createElement("div");

    rawHTML.className = "rc__descriptions";

    const descriptions = [
      "25% OFF every order",
      "Custom plans",
      "Free shipping",
      "Update plan at any time",
    ];

    rawHTML.innerHTML = `
     ${descriptions
       .map(
         (item) =>
           `
         <div class="rc__descriptions-item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4073_7609)">
            <path d="M3.125 11.25L7.5 15.625L17.5 5.625" stroke="#05C3DD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_4073_7609">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            <span>${item}</span>
        </div>
        `
       )
       .join(" ")}
    `;
    dropdownContainer.appendChild(rawHTML);
  };

  const handleSubscriptionTitle = () => {
    const oneTimeTitle = document.querySelector(
      ".onetime-radio .rc-radio__label"
    );
    const price = oneTimeTitle.innerHTML.match(/\$\d+(\.\d{2})?/)[0];
    oneTimeTitle.innerHTML = `One - time Purchase <span>${price}</span>`;

    const priceSubscription = document.querySelector(
      ".subscription-radio .rc-radio__price"
    );
    priceSubscription.innerHTML = `<span class="old__price">${price}</span> ${priceSubscription.innerHTML}`;
    const titleSubscription = document.querySelector(".rc-radio__subscription");
    const percentDiscount = titleSubscription.innerHTML.match(/(\d+)%/)[1];
    titleSubscription.innerHTML = `Subscribe & Save <span class="badge">  ${percentDiscount}% Off</span`;
  };

  const handleOptionTitle = () => {
    const options = document.querySelectorAll(
      ".rc-selling-plans-dropdown__select option"
    );
    options.forEach((item) => {
      const text = item.innerHTML;
      const splitText = text.split("Delivery");
      const splitTextAfter = splitText[1] ? splitText[1].trim() : "";

      item.innerHTML = `
        <span class="bold">Delivery:</span>
        <span>${splitTextAfter.charAt(0).toUpperCase() + splitTextAfter.slice(1).toLowerCase()}</span>
      `;
    });
  };

  const timer = setInterval(() => {
    let dropdownContainer = document.querySelector(
      ".rc-selling-plans-dropdown"
    );

    if (dropdownContainer) {
      clearInterval(timer);
      addDescription();
      mutationSubscription();
      handleSubscriptionTitle();
      handleOptionTitle();
    }

    if (duration === 3000) clearInterval(timer);

    duration = duration + 100;
  }, 100);
};

const handleReviewsApp = () => {
  const targetDiv = document.querySelector(".jdgm-widget.jdgm-review-widget ");

  if (targetDiv) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "attributes") {
          if (mutation.attributeName === "data-widget-name") {
            const starsRow = targetDiv.querySelectorAll(".jdgm-histogram__row");
            starsRow.forEach((ele) => {
              const dataRating = ele.getAttribute("data-rating");
              const starts = ele.querySelector(".jdgm-histogram__star");
              if (starts) {
                starts.innerHTML = dataRating;
              }
            });

            const votes = document.querySelectorAll(".jdgm-rev__votes-inner");
            votes.forEach((item) => {
              const newSpan = document.createElement("span");
              newSpan.className = "votes__text";
              newSpan.innerHTML = `Was this review helpful?`;
              item.prepend(newSpan);
            });

            const dropdownWrapper = document.querySelector(
              ".jdgm-rev-widg__sort-wrapper"
            );

            if (dropdownWrapper) {
              // update dropdown
              const sortDropdown = dropdownWrapper.querySelector(
                '.jdgm-sort-dropdown[aria-label="Sort dropdown"]'
              );
              if (!sortDropdown) return;
              const oldOptions = sortDropdown.querySelectorAll("option");
              oldOptions.forEach((e) => {
                e.textContent = `Rating: ${e.textContent}`;
              });

              const newDropdownWrapper = document.createElement("div");
              newDropdownWrapper.className = "jdgm-sort-dropdown-wrapper";
              const newSelect = document.createElement("select");
              newSelect.className = "jdgm-sort-dropdown";
              const opt = document.createElement("option");
              opt.value = "all";
              opt.innerHTML = `Rating: All`;
              newSelect.appendChild(opt);
              for (var i = 5; i > 0; i--) {
                const opt = document.createElement("option");
                opt.value = i;
                opt.innerHTML = `Rating: ${i} stars`;
                newSelect.appendChild(opt);
              }
              const newArrow = document.createElement("span");
              newArrow.className = "jdgm-sort-dropdown-arrow";
              newDropdownWrapper.appendChild(newSelect);
              newDropdownWrapper.appendChild(newArrow);
              newSelect.addEventListener("change", (e) => {
                const value = e.target.value;
                if (value === "all") {
                  const clearFilterElement = document.querySelector(
                    ".jdgm-histogram__clear-filter"
                  );
                  clearFilterElement && clearFilterElement.click();
                }
                const targetStar = document.querySelector(
                  `.jdgm-histogram__row[data-rating="${value}"]`
                );
                targetStar.click();
              });

              dropdownWrapper.appendChild(newDropdownWrapper);
            }

            const badgeVerifiedBuyer = targetDiv.querySelectorAll(
              ".jdgm-rev__buyer-badge"
            );

            badgeVerifiedBuyer.forEach((item) => {
              item.innerHTML = `
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4073_8212)">
                <path d="M7.5 1.40625C6.29477 1.40625 5.11661 1.76364 4.1145 2.43323C3.11238 3.10282 2.33133 4.05454 1.87011 5.16802C1.40889 6.28151 1.28821 7.50676 1.52334 8.68883C1.75847 9.8709 2.33884 10.9567 3.19107 11.8089C4.0433 12.6612 5.1291 13.2415 6.31117 13.4767C7.49324 13.7118 8.71849 13.5911 9.83198 13.1299C10.9455 12.6687 11.8972 11.8876 12.5668 10.8855C13.2364 9.88339 13.5938 8.70523 13.5938 7.5C13.592 5.88436 12.9495 4.33538 11.807 3.19295C10.6646 2.05052 9.11564 1.40796 7.5 1.40625ZM10.1754 6.42539L6.89414 9.70664C6.85061 9.75022 6.79891 9.7848 6.74201 9.80839C6.6851 9.83198 6.6241 9.84412 6.5625 9.84412C6.5009 9.84412 6.4399 9.83198 6.383 9.80839C6.32609 9.7848 6.2744 9.75022 6.23086 9.70664L4.82461 8.30039C4.73666 8.21243 4.68724 8.09314 4.68724 7.96875C4.68724 7.84436 4.73666 7.72507 4.82461 7.63711C4.91257 7.54915 5.03186 7.49974 5.15625 7.49974C5.28064 7.49974 5.39994 7.54915 5.48789 7.63711L6.5625 8.71231L9.51211 5.76211C9.55566 5.71856 9.60737 5.68401 9.66427 5.66044C9.72117 5.63687 9.78216 5.62474 9.84375 5.62474C9.90534 5.62474 9.96633 5.63687 10.0232 5.66044C10.0801 5.68401 10.1318 5.71856 10.1754 5.76211C10.2189 5.80566 10.2535 5.85736 10.2771 5.91427C10.3006 5.97117 10.3128 6.03216 10.3128 6.09375C10.3128 6.15534 10.3006 6.21633 10.2771 6.27323C10.2535 6.33014 10.2189 6.38184 10.1754 6.42539Z" fill="#38BC55"/>
                </g>
                <defs>
                <clipPath id="clip0_4073_8212">
                <rect width="15" height="15" fill="white"/>
                </clipPath>
                </defs>
                </svg>
              <span>Verified Buyer</span>
              `;
            });
          }
        }
      });
    });

    const config = {
      childList: true, // Theo dõi sự thay đổi của các phần tử con
      attributes: true, // Theo dõi sự thay đổi của thuộc tính
      subtree: true, // Theo dõi cả các phần tử con trong cây DOM
    };

    observer.observe(targetDiv, config);
  }
};

// START FUNC PRODUCT PAGE
const PRODUCT_PAGE = (() => {
  handleRechargeApp();
  handleReviewsApp();
})();
